import { render, staticRenderFns } from "./PrizeItem.vue?vue&type=template&id=0cbd95e4&scoped=true"
import script from "./PrizeItem.vue?vue&type=script&lang=js"
export * from "./PrizeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbd95e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cbd95e4')) {
      api.createRecord('0cbd95e4', component.options)
    } else {
      api.reload('0cbd95e4', component.options)
    }
    module.hot.accept("./PrizeItem.vue?vue&type=template&id=0cbd95e4&scoped=true", function () {
      api.rerender('0cbd95e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/lottery-assistant/activity/components/PrizeItem.vue"
export default component.exports